module.exports = __webpack_public_path__ + "media/bg.e4c96191.mp3";